import {UI} from "../../../stem-core/src/ui/UIBase";

import {Dispatcher} from "../../../stem-core/src/base/Dispatcher";


export const WidgetActiveRouteElementBuilder = (BaseClass=UI.Element) => class Element extends BaseClass {
    static instance;

    dispatchHeightChange() {
        // TODO @cleanup why the dispatch and not just call a function?
        const desiredWidgetHeight = this.computeHeight();
        Dispatcher.Global.dispatch("widgetAnimationUpdateHeight", desiredWidgetHeight);
    }

    /*
    * This method should tell the intended iframe height of the widget when this class is the active route element.
    * The height should not include any extra height made by the error banner appearance.
    */
    computeHeight() {
        return this.getHeight();
    }

    onMount() {
        this.constructor.instance = this;

        super.onMount();
    }
};

export const WidgetActiveRouteElement = WidgetActiveRouteElementBuilder();
